import React, { useEffect, useState } from "react";
import "./cartcom.css";
import { useInstructions } from "../../APIContext/InstructionsContext";
import { useNewUser } from "../../APIContext/NewUserContext";
import { useNavigate } from "react-router-dom";
import empty_cart_img from "../../Assets/Images/Cart/empty_cart.png";
import Swal from "sweetalert2";
import CartTable from "./cartTable";
import { useSummerCamp } from "../../APIContext/summerCampContext";
import Loader from "../Loader/Loader";

function CartCom() {
  const { fetchCartItems, cartItems, removeFromCart } = useInstructions();
  const { loading, fetchCartItemsNew, cartItemsNew, removeFromCartNew } =
    useNewUser();
  const { getOfferingCart, deleteOfferingById, isDeleting } = useSummerCamp();

  const [cartItemsforPage, setCartItemsforPage] = useState([]);
  const [summerCampCartItems, setSummerCampCartItems] = useState([]);
  const [activeTab, setActiveTab] = useState("summer");

  const navigate = useNavigate();
  const user = localStorage.getItem("user");

  useEffect(() => {
    if (user) fetchCartItems();
    else fetchCartItemsNew();
  }, [user]);

  useEffect(() => {
    if (user) setCartItemsforPage(cartItems || []);
    else setCartItemsforPage(cartItemsNew || []);
  }, [cartItems, cartItemsNew, user]);

  const fetchCart = async () => {
    const data = await getOfferingCart();
    if (Array.isArray(data)) setSummerCampCartItems(data);
  };

  useEffect(() => {
    fetchCart();
  }, []);

  const handledeleteCart = async (itemId) => {
    const result = await Swal.fire({
      icon: "warning",
      title: "Remove item from cart?",
      text: "Are you sure you want to delete this item from your cart?",
      showConfirmButton: true,
      confirmButtonText: "Yes, Delete",
      showCancelButton: true,
      cancelButtonText: "Cancel",
      confirmButtonColor: "#f7931a",
      cancelButtonColor: "#1C1C1C",
      reverseButtons: true,
    });

    if (!result.isConfirmed) return;

    if (user) await removeFromCart(itemId);
    else await removeFromCartNew(itemId);
  };

  const handleDeleteSummerCampCartItem = async (itemId) => {
    const result = await Swal.fire({
      icon: "warning",
      title: "Remove item from cart?",
      text: "Are you sure you want to delete this item from your cart?",
      showConfirmButton: true,
      confirmButtonText: "Yes, Delete",
      showCancelButton: true,
      cancelButtonText: "Cancel",
      confirmButtonColor: "#f7931a",
      cancelButtonColor: "#1C1C1C",
      reverseButtons: true,
    });

    if (!result.isConfirmed) return;

    await deleteOfferingById(itemId);
    await fetchCart();
  };

  const cartTotal = cartItemsforPage?.summary?.subtotal;
  const summerCampCartTotal = summerCampCartItems?.reduce(
    (total, item) => total + Number(item.total_price),
    0,
  );

  const handleSummerCampCartCheckOut = () => {
    if (summerCampCartItems.length > 1) {
      Swal.fire({
        icon: "warning",
        title: "Multiple Summer Camps Detected",
        text: "Only one summer camp can be checked out at a time.",
      });
      return;
    }
    navigate(`/summer-camp-checkout/${user ? "authenticated" : "newUser"}`);
  };

  const productCount = cartItemsforPage?.items?.length || 0;
  const summerCount = summerCampCartItems?.length || 0;
  if (isDeleting || loading) return <Loader />;

  return (
    <div style={{ filter: "brightness(1.28)" }} className="bg-custom">
      <div className="cart-page">
        {/* 🧺 BOTH EMPTY */}
        {summerCount === 0 && productCount === 0 && (
          <>
            <div className="empty-cart">
              <img src={empty_cart_img} alt="empty" />
              <p className="empty-text text-clip">YOUR CART IS EMPTY!</p>
            </div>
            <div className="proceed-checkout-btn btn">
              <button onClick={() => navigate("/")}>
                <span className="text-clip">Return To Home</span>
              </button>
            </div>
          </>
        )}

        {/* 🏕️ ONLY SUMMER CAMP */}
        {summerCount > 0 && productCount === 0 && (
          <>
            <CartTable
              items={summerCampCartItems}
              cartTotal={summerCampCartTotal}
              onDelete={handleDeleteSummerCampCartItem}
              titleHeader="Summer Camp"
              isSummerCamp
              descriptionHeader="Summer Camp Description"
            />
            <div className="proceed-checkout-btn btn">
              <button onClick={handleSummerCampCartCheckOut}>
                Proceed to Checkout
              </button>
            </div>
          </>
        )}

        {/* 🛒 ONLY PRODUCTS */}
        {productCount > 0 && summerCount === 0 && (
          <>
            <CartTable
              items={cartItemsforPage.items}
              cartTotal={cartTotal}
              onDelete={handledeleteCart}
              titleHeader="Product"
              isSummerCamp={false}
              descriptionHeader="Product Description"
            />
            <div className="proceed-checkout-btn btn">
              <button onClick={() => navigate("/checkout")}>
                <span className="text-clip">Proceed to Checkout</span>
              </button>
            </div>
          </>
        )}

        {/* 🔀 BOTH PRESENT → TABS */}
        {summerCount > 0 && productCount > 0 && (
          <>
            <div className="cart-toggle">
              <button
                className={activeTab === "summer" ? "active" : ""}
                onClick={() => setActiveTab("summer")}
              >
                Summer Camp ({summerCount})
              </button>
              <button
                className={activeTab === "product" ? "active" : ""}
                onClick={() => setActiveTab("product")}
              >
                Products ({productCount})
              </button>
            </div>

            {activeTab === "summer" && (
              <>
                <CartTable
                  items={summerCampCartItems}
                  cartTotal={summerCampCartTotal}
                  onDelete={handleDeleteSummerCampCartItem}
                  titleHeader="Summer Camp"
                  isSummerCamp
                  descriptionHeader="Summer Camp Description"
                />
                <div className="proceed-checkout-btn btn">
                  <button onClick={handleSummerCampCartCheckOut}>
                    <span className="text-clip">Proceed to Checkout</span>
                  </button>
                </div>
              </>
            )}

            {activeTab === "product" && (
              <>
                <CartTable
                  items={cartItemsforPage.items}
                  cartTotal={cartTotal}
                  onDelete={handledeleteCart}
                  titleHeader="Product"
                  isSummerCamp={false}
                  descriptionHeader="Product Description"
                />
                <div className="proceed-checkout-btn btn">
                  <button onClick={() => navigate("/checkout")}>
                    Proceed to Checkout
                  </button>
                </div>
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
}

export default CartCom;
